<template>
  <div class="split">
<!--    <div class="header" v-if="list && list.length > 0">-->
<!--      该订单已被拆成{{list.length}}个包裹-->
<!--    </div>-->
    <ul>
      <li v-if="list && list.length > 0" v-for="(item, index) of list" :key="index">
        <div class="address" :class="{'order-top-pad': item.relationOrders.length > 0}">
          <span class="f12 color-FC0324" @click="relationordersFn(item)" v-if="item.relationOrders.length > 0">查看补发订单</span>
          <ul>
            <li class="trans">
              <p @click="transClick(item)"><img src="../../assets/images/logistics.png">{{item.trans_title}}<img src="../../assets/images/jt3.png"></p>
              <span>{{item.trans_desc}}</span>
              <span class="transTime"><b>{{item.tran_time}}</b><b>子订单编号：{{item.no}}</b></span>
            </li>
          </ul>
        </div>
        <div class="list">
          <ul>
            <li v-if="item.itemlist"  v-for="(itemSon, index) of item.itemlist" :key="index" @click="productDetailFn(itemSon)">
              <div class="product">
                <div class="productBox">
                  <div class="img">
                    <img v-lazy="itemSon.img_path">
                    <goods-tag :goods="itemSon"></goods-tag>
                  </div>
                  <div class="proContent">
                    <b>{{itemSon.name.length > 26 ? itemSon.name.slice(0, 26) + '...' : itemSon.name}}</b>
                    <p>
                      <b>{{itemSon.spec}}</b>
                    </p>
                  </div>
                </div>
                <span v-if="item.itemlist" class="totalPrice totalPriceNoShadow">
                  <b>共{{itemSon.nums}}件</b>
                </span>
              </div>
              <div class="proFooter" style="padding-bottom: 0;padding-right: 0;margin-right: 0;" >
                <div class="p">
                </div>
                <div class="proBtn">
                  <button @click.stop="afterSalesFn(0, itemSon, item)" class="grayBtn" v-if="itemSon.orderstatus == 2 && (itemSon.isgift != 1 || (itemSon.isgift == 1 && parseFloat(itemSon.price).toFixed(2) > 0)) && itemSon.isprogift != 1 && item.is_show_refund_button == 1 && itemSon.is_show_refund_button == 1">申请退款</button>
                  <button @click.stop="afterSalesFn(0, itemSon, item)" class="grayBtn" v-if="(itemSon.orderstatus == 7 || itemSon.orderstatus == 8 || itemSon.orderstatus == 3) && (itemSon.isgift != 1 || (itemSon.isgift == 1 && parseFloat(itemSon.price).toFixed(2) > 0)) && itemSon.isprogift != 1 && item.is_show_refund_button == 1 && itemSon.is_show_refund_button == 1">申请售后</button>
                  <button @click.stop="afterDetailsClick('0', itemSon)" class="grayBtn" v-if="(itemSon.orderstatus == 4 || itemSon.orderstatus == 5) && (itemSon.isgift != 1 || (itemSon.isgift == 1 && parseFloat(itemSon.price).toFixed(2) > 0)) && itemSon.isprogift != 1 && itemSon.refund_id != ''">售后详情</button>
                  <button class="redBtn" v-if="item.itemlist.length <= 1 && (itemSon.orderstatus == 7 || itemSon.orderstatus == 8)" @click.stop="confirm(item)">确认收货</button>
                </div>
              </div>
            </li>
          </ul>
          <div class="proFooter" v-if="item.itemlist.length > 1">
            <div class="p">
            </div>
            <div class="proBtn">
              <button class="grayBtn" v-if="item.isRefundButton > 1 && item.orderstatus == 2 && item.is_show_refund_button == 1" @click="afterSalesFn(1, item)">批量退款</button>
              <button class="grayBtn" v-if="item.isRefundButton > 1 && (item.orderstatus == 7 || item.orderstatus == 8) && item.is_show_refund_button == 1" @click="afterSalesFn(1, item)">申请售后</button>
              <button class="redBtn" v-if="item.itemlist.length > 1 && item.orderstatus == 7 || item.orderstatus == 8" @click="confirm(item)">确认收货</button>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <van-dialog
      class="collect_button_alert after-sales-dialog"
      v-model="afterSalesShow"
      :message="afterSalesMessage"
      :before-close="beforeClose"
      @confirm="confirmDialog"
      @cancel="cancelDialog"
      confirm-button-text="联系客服"
      confirm-button-color="#FFFCFC"
      cancel-button-text="拨打电话"
      cancel-button-color="#FC0324"
      show-confirm-button
      show-cancel-button>
      <div slot="title">
        <img class="dialog-close" @click="closeDialogFn" src="../../assets/images/close3.png">
      </div>
    </van-dialog>
  </div>
</template>

<script>
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import Vue from 'vue'
import { isWeixin, fenxiang } from '../../assets/common/js/config'
import { customRequestAjax } from '@/axiosApi'
import goodsTag from '../common/goodsTag'
Vue.use(VueAwesomeSwiper, /* { default global options } */)

export default {
  name: 'splitDetails',
  components: {
    goodsTag
  },
  data () {
    return {
      id: this.$route.query.id != '' ? this.$route.query.id : '',
      list: [],
      prizetip: '',
      afterSalesShow: false,
      afterSalesMessage: '',
      kefuPhone: '',
      isChangebuyRefundTip: ''
      // swiperOption: {
      //   autoplay: false,
      //   slidesPerView: 'auto',
      //   slidesPerGroup: 2,
      //   observer: true,
      //   observeParents: true,
      //   spaceBetween: 10
      // }
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({path: 'splitdetails'})
    }
    this.getData()
  },
  methods: {
    getData: function () {
      var url = 'Wxmall/Ordermanage/getParentOrderById?id=' + this.id
      var that = this
      if (this.id != '') {
        customRequestAjax(url).then(res => {
          if (res.data.code === 200) {
            that.list = res.data.list
            that.prizetip = res.data.prizetip
            // that.isChangebuyRefundTip = res.data.is_changebuy_refund_tip
            that.list.map(function (item) {
              item.isRefundButton = 0
              if (item.itemlist.length) {
                item.itemlist.map(function (itemSon) {
                  if ((itemSon.isgift != 1 || (itemSon.isgift == 1 && parseFloat(itemSon.price).toFixed(2) > 0))
                    && itemSon.isprogift != 1 && itemSon.is_show_refund_button == 1) {
                    item.isRefundButton++
                  }
                })
              }
            })
          }
        })
      }
    },
    relationordersFn: function (item) {
      this.$router.push({
        path: '/orderdetails',
        query: {
          id: item.relationOrders[0].id
        }
      })
    },
    productDetailFn (items) {
      if (items.limitid) {
        window.location.href = '/static/wx/html/time-limit-actpage/timelimitproduct.html?limitid=' + items.limitid
      } else if (items.integralitemid && items.integralitemid != '') {
        this.$router.push({
          path: '/integralproduct',
          query: {
            itemid: items.integralitemid,
            integralType: items.integraltype == 1 ? 0 : 1,
            integral: items.integralcount,
            status: items.integralstatus,
            itembaseid: items.itembaseid
          }
        })
      } else if (this.$route.query.is_coupon != 1 && items.isgoiteminfo == 1 && items.isadditem != 1 && items.isprogift == 0 && items.ischangebuy == 0 && items.isgift == 0 && items.isexchangebuy != 1) {
        this.$clickburiedPoint({
          url: 'ckysdatacenter/itemclick/save',
          data: {
            itemid: items.itembaseid,
            scenepoint: 'SUBORDERDETAIL',
            scenedesc: this.id
          }
        })
        this.$router.push({
          path: '/productdetail',
          query: {
            itemid: items.itembaseid,
            live_id: items.liveid
          }
        })
      } else if (items.ischangebuy == 1 || items.isexchangebuy == 1 || items.isgift == 1 || items.isdefectivegood == 1) {
        this.$router.push({
          path: '/productdetail',
          query: {
            itemid: items.itembaseid,
            type: 'changebuyproductdetail',
            gift: items.isgift ? 'gift' : ''
          }
        })
      }
    },
    closeDialogFn: function () {
      this.afterSalesShow = false
    },
    beforeClose: function (action, done) {
      if (action === 'confirm') {
        setTimeout(done, 1000)
      } else {
        done(false)
      }
    },
    confirmDialog: function () {
      this.keFu()
      this.afterSalesShow = false
    },
    cancelDialog: function () {
      window.location.href = 'tel: ' + this.kefuPhone
    },
    // 申请退款
    afterSalesFn (numtype, items, itemFa) {
      var that = this
      var url
      if (numtype == 0) {
        if (itemFa.is_part_refund == 0 && itemFa.orderstatus == 2) {
          that.$toast('当前时间暂时无法申请部分退款，请稍后再试！')
        } else if (itemFa.is_zg_order == 1) {
          that.$toast('当前商品为专柜商品，不能申请售后')
        } else {
          if (that.isChangebuyRefundTip) {
            that.$dialog.alert({
              message: that.isChangebuyRefundTip,
              className: 'percen_button_alert',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '知道了',
              closeOnPopstate: false
            }).then(function () {
              // on confirm
              f()
            }).catch(function () {
              // on cancel
            })
          } else {
            f()
          }
          function f () {
            url = 'Wxmall/OrderRefund/checkOrderRefund?oid=' + itemFa.id
            customRequestAjax(url).then(res => {
              if (res.data.code === 200) {
                var url1 = 'Wxmall/OrderRefund/getRefundActivityPrizeTip?ordersheet_id=' + items.ordersheet_id
                if (!that.prizetip) {
                  that.$router.push({
                    path: '/aftertype',
                    query: {
                      type: numtype,
                      id: items.ordersheet_id
                    }
                  })
                  return
                }
                customRequestAjax(url1).then(res1 => {
                  if (res1.data.code == 200 && res1.data.data.prizetip != '') {
                    that.$dialog.confirm({
                      message: res1.data.data.prizetip,
                      className: 'collect_button_alert',
                      cancelButtonColor: '#FC0324',
                      confirmButtonColor: '#FFFCFC',
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      closeOnPopstate: true
                    }).then(function () {
                      // on confirm
                      that.$router.push({
                        path: '/aftertype',
                        query: {
                          type: numtype,
                          id: items.ordersheet_id
                        }
                      })
                    }).catch(function () {
                      // on cancel
                    })
                  } else {
                    that.$router.push({
                      path: '/aftertype',
                      query: {
                        type: numtype,
                        id: items.ordersheet_id
                      }
                    })
                  }
                })
              } else if (res.data.code == 6006) {
                that.afterSalesMessage = res.data.msg
                that.kefuPhone = res.data.phone
                that.afterSalesShow = true
              }
            })
          }
        }
      } else if (numtype == 1) {
        if (items.is_part_refund == 0 && items.orderstatus == 2) {
          that.$toast('当前时间暂时无法申请部分退款，请稍后再试！')
        } else if (items.is_zg_order == 1) {
          that.$toast('当前商品为专柜商品，不能申请售后')
        } else {
          if (that.isChangebuyRefundTip) {
            that.$dialog.alert({
              message: that.isChangebuyRefundTip,
              className: 'percen_button_alert',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '知道了',
              closeOnPopstate: false
            }).then(function () {
              // on confirm
              g()
            }).catch(function () {
              // on cancel
            })
          } else {
            g()
          }
          function g () {
            url = 'Wxmall/OrderRefund/checkOrderRefund?oid=' + items.id
            customRequestAjax(url).then(res => {
              if (res.data.code === 200) {
                var url1 = 'Wxmall/OrderRefund/getRefundActivityPrizeTip?orderid=' + items.id
                if (!that.prizetip) {
                  that.$router.push({
                    path: '/aftertype',
                    query: {
                      type: numtype,
                      id: items.id
                    }
                  })
                  return
                }
                customRequestAjax(url1).then(res1 => {
                  if (res1.data.code == 200 && res1.data.data.prizetip != '') {
                    that.$dialog.confirm({
                      message: res1.data.data.prizetip,
                      className: 'collect_button_alert',
                      cancelButtonColor: '#FC0324',
                      confirmButtonColor: '#FFFCFC',
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      closeOnPopstate: true
                    }).then(function () {
                      // on confirm
                      that.$router.push({
                        path: '/aftertype',
                        query: {
                          type: numtype,
                          id: items.id
                        }
                      })
                    }).catch(function () {
                      // on cancel
                    })
                  } else {
                    that.$router.push({
                      path: '/aftertype',
                      query: {
                        type: numtype,
                        id: items.id
                      }
                    })
                  }
                })
              } else if (res.data.code == 6006) {
                that.afterSalesMessage = res.data.msg
                that.kefuPhone = res.data.phone
                that.afterSalesShow = true
              }
            })
          }
        }
      }
    },
    afterDetailsClick: function (numtype, items) {
      if (numtype == 0) {
        this.$router.push({
          path: '/afterdetails',
          query: {
            id: items.refund_id
          }
        })
      }
      // else {
      //   this.$router.push({
      //     path: '/afterdetails',
      //     query: {
      //       id: id
      //     }
      //   })
      // }

    },
    confirm: function (items) {
      var url = 'Wxmall/Ordermanage/confirmOrderItem'
      var data = {
        id: items.id
      }
      var that = this
      if (items.issplit == 1) {
        that.$router.push({path: '/splitdetails',
          query: {
            id: items.id,
            is_coupon: this.$route.query.is_coupon ? this.$route.query.is_coupon : 0
          }
        })
      } else {
        if (items.orderstatus == 8) {
          this.$dialog.alert({
            message: '您的包裹还没有全部发货，不能确认收货！',
            className: 'percen_button_alert',
            confirmButtonColor: '#FFFCFC',
            confirmButtonText: '知道了',
            closeOnPopstate: false
          }).then(function () {
            // on confirm
          }).catch(function () {
            // on cancel
          })
        } else {
          this.$dialog.confirm({
            message: '确认收货？',
            className: 'collect_button_alert',
            cancelButtonColor: '#FC0324',
            confirmButtonColor: '#FFFCFC',
            closeOnPopstate: true
          }).then(function () {
            customRequestAjax.post(url, data).then(res => {
              if (res.data.code === 200) {
                that.$store.commit('ORDER_INIT_DATA', 1)
                if (res.data.noticmsg) that.$toast(res.data.noticmsg)
                that.getData()
              }
            })
          }).catch(function () {
            // on cancel
          })
        }
      }
    },
    transClick: function (items) {
      if (items.isparcellist == 1) {
        this.$router.push({path: '/splitdetails_order',
          query: {
            id: items.id
          }
        })
      } else {
        this.$router.push({path: '/logistics',
          query: {
            id: items.id
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.list ul li p, .product {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -moz-justify-content: space-between;
  -ms-justify-content: space-between;
  -webkit-justify-content: space-between;
  -o-justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
}
.split {
  >ul {
    >li {
      margin-bottom: 0.11rem;
    }
  }
  .header {
    font-size: 0.12rem;
    color: #FAAF40;
    height: 0.33rem;
    line-height: 0.33rem;
    padding-left: 0.11rem;
    background: #FFF7EF;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 10;
  }
  .address {
    background: #fff;
    border-radius: 0.03rem;
    padding: 0.2rem 0.15rem 0.1rem;
    margin:0.1rem 0.11rem 0;
    &.order-top-pad {
      padding-top: 0.35rem;
      position: relative;
    }
    >span {
      position: absolute;
      right: 0;
      top: 0;
      display: block;
      background: #FFECEF;
      padding: 0.04rem 0.11rem;
      border-radius: 0 0.03rem 0 0.03rem;
    }
    ul {
      li{
        p{
          display: flex;
          display: -webkit-flex;
          display: -ms-flex;
          display: -o-flex;
          display: -moz-flex;
          align-items: center;
          -webkit-align-items: center;
          -ms-align-items: center;
          -o-align-items: center;
          -moz-align-items: center;
          font-size:0.12rem;
          font-weight:600;
          color:rgba(29,30,30,1);
          line-height:0.17rem;
          b {
            display: flex;
            display: -webkit-flex;
            display: -ms-flex;
            display: -o-flex;
            display: -moz-flex;
            align-items: center;
            -webkit-align-items: center;
            -ms-align-items: center;
            -o-align-items: center;
            -moz-align-items: center;
          }
          img{
            &:first-of-type {
              width: 0.18rem;
              height: 0.16rem;
              margin-right: 0.05rem;
            }
            &:last-of-type {
              width: 0.1rem;
              height: 0.1rem;
              padding: 0 0.015rem;
              margin-left: 0.05rem;
            }
          }
        }
        span {
          color:#6C6C6C;
          line-height:0.16rem;
          margin-top: 0.06rem;
          padding-left: 0.23rem;
          /*overflow: hidden;*/
          font-size:0.11rem;
          /*white-space: nowrap;*/
          display: block;
          &.transTime {
            font-size:0;
            position: relative;
            height: 0.16rem;
          }
          b {
            position: absolute;
            top: 0;
            font-weight:400;
            font-size:0.1rem;
            line-height:0.14rem;
            transform: scale(0.93 );
            -webkit-transform: scale(0.93 );
            -moz-transform: scale(0.93  );
            -ms-transform: scale(0.93 );
            -o-transform: scale(0.93  );
            &:first-of-type {
              left: 0.18rem;
            }
            &:last-of-type {
              right: -0.06rem;
            }
          }
        }
      }
    }
  }
  .list {
    >ul {
      >li {
        background: #fff;
        margin: 0 0.11rem 0;
        padding: 0 0.15rem 0.2rem;
        >p {
          border-bottom: 1px solid #EFEFEF;
          padding-bottom: 0.1rem;
          span {
            display: block;
            b {
              display: block;
              font-weight: 400;
              color: #444444;
              font-size:0.12rem;
              float: left;
              &:last-of-type {
                margin-left: 0.04rem;
                line-height: 0.19rem;
                float: left;
                img {
                  width: 0.19rem;
                  height: 0.19rem;
                  float: right;
                }
              }
            }
          }
          >b {
            display: flex;
            display: -webkit-flex;
            display: -moz-flex;
            display: -ms-flex;
            display: -o-flex;
            align-items: center;
            -webkit-align-items: center;
            -moz-align-items: center;
            -ms-align-items: center;
            -o-align-items: center;
            i {
              display: inline-block;
              font-style: normal;
              color: #292929;
              font-size: 0.12rem;
              line-height: 0.16rem;
              float: left;
              font-weight:400;
            }
            b{
              display: inline-block;
              border-left: 1px solid #D8D8D8;
              margin-left: 0.06rem;
              padding-left: 0.07rem;
              img {
                width:0.12rem;
                height:0.12rem;
              }
            }
          }
        }
        .product {
          /*margin-top: 0.16rem;*/
          position: relative;
          .productBox {
            display: flex;
            display: -moz-flex;
            display: -ms-flex;
            display: -webkit-flex;
            display: -o-flex;
            .img {
              position: relative;
              img {
                &:first-of-type {
                  width: 100%;
                  height: 100%;
                }
              }
              width: 0.8rem;
              height: 0.8rem;
            }
            .proContent {
              margin-left: 0.07rem;
              margin-top: 0.08rem;
              flex: 1;
              -webkit-flex: 1;
              -moz-flex: 1;
              -ms-flex: 1;
              -o-flex: 1;
              >b {
                font-size:0.13rem;
                font-weight:400;
                color:rgba(41,41,41,1);
                line-height:0.18rem;
                display: block;
                margin-bottom: 0.05rem;
              }
              >p{
                align-items: flex-start;
                -moz-align-items: flex-start;
                -ms-align-items: flex-start;
                -webkit-align-items: flex-start;
                -o-align-items: flex-start;
                >b {
                  font-size:0.11rem;
                  font-weight:400;
                  color:rgba(108,108,108,1);
                  line-height:0.16rem;
                  display: block;
                }
              }
            }
          }
          .totalPrice {
            z-index: 10;
            opacity:0.85;
            height: 0.8rem;
            display: flex;
            display: -webkit-flex;
            display: -o-flex;
            display: -ms-flex;
            display: -moz-flex;
            flex-direction: column;
            -webkit-flex-direction: column;
            -o-flex-direction: column;
            -ms-flex-direction: column;
            -moz-flex-direction: column;
            justify-content: center;
            -webkit-justify-content: center;
            -o-justify-content: center;
            -ms-justify-content: center;
            -moz-justify-content: center;
            .price {
              display: flex;
              display: -webkit-flex;
              display: -o-flex;
              display: -ms-flex;
              display: -moz-flex;
              align-items: flex-end;
              -webkit-align-items: flex-end;
              -o-align-items: flex-end;
              -ms-align-items: flex-end;
              -moz-align-items: flex-end;
              font-size: 0.14rem;
              font-weight:600;
              color:#222222;
              line-height:0.14rem;
              &:before {
                content: '￥';
                font-size:0.10rem;
                font-weight:600;
                line-height: 0.14rem;
              }
              i {
                font-size: 0.11rem;
                font-style: normal;
                line-height: 0.14rem;
              }
            }
            >b {
              color: #908D8D;
              font-size: 0.11rem;
              line-height: 0.16rem;
              display: block;
              font-weight:400;
              text-align: center;
              white-space: nowrap;
            }
          }
          .bestSellingSwiper {
            padding-right: 0.6rem;
            width: 100%;
            .swiper-container {
              padding-right: 0.6rem;
              .swiper-wrapper {
                >.swiper-slide {
                  width: 0.8rem;
                  position: relative;
                  background-color: white;
                  .img {
                    width: 0.8rem;
                    height: 0.8rem;
                    position: relative;
                    img {
                      &:first-of-type {
                        width: 100%;
                        height: 100%;
                      }
                    }
                  }
                }
              }
            }
            &+.totalPriceNoShadow+.totalPriceShadow {
              background:rgba(255,255,255,1);
              box-shadow:-0.2rem 0 0.09rem -0.16rem rgba(156,156,156,0.5);
              -webkit-box-shadow:-0.2rem 0 0.09rem -0.16rem rgba(156,156,156,0.5);
              -moz-box-shadow:-0.2rem 0 0.09rem -0.16rem rgba(156,156,156,0.5);
              -ms-box-shadow:-0.2rem 0 0.09rem -0.16rem rgba(156,156,156,0.5);
              -o-box-shadow:-0.2rem 0 0.09rem -0.16rem rgba(156,156,156,0.5);
            }
            &+.totalPriceNoShadow {
              background:rgba(255,255,255,1);
            }
          }
        }
      }
    }
    .proFooter {
      overflow: hidden;
      padding-top: 0.1rem;
      padding-bottom: 0.2rem;
      padding-right: 0.15rem;
      margin: 0 0.11rem 0;
      background: #fff;
      >.p {
        font-size:0.1rem;
        font-weight:400;
        color:rgba(252,3,36,1);
        line-height:0.26rem;
        float: left;
      }
      .proBtn {
        display: flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -webkit-flex;
        display: -o-flex;
        float: right;
        .grayBtn {
          min-width:0.7rem;
          height: 0.27rem;
          display: block;
          margin-left: 0.1rem;
          border-radius:0.14rem;
          border:1px solid rgba(96,96,96,1);
          font-size:0.12rem;
          font-weight:400;
          color:rgba(38,38,38,1);
          line-height:0.17rem;
          padding: 0.05rem 0.11rem;
          background: none;
          outline: none;
        }
        .redBtn {
          min-width:0.7rem;
          height: 0.27rem;
          display: block;
          margin-left: 0.1rem;
          border-radius:0.14rem;
          border:1px solid #FC0324;
          font-size:0.12rem;
          font-weight:400;
          color:#FC0324;
          line-height:0.17rem;
          padding: 0.05rem 0.11rem;
          background: none;
          outline: none;
        }
      }
    }
  }
  .dialog-close {
    width: 0.2rem;
    height: 0.2rem;
    position: absolute;
    top: 0.06rem;
    right: 0.06rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/splitDetails.vue